"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../shared/controllers/BaseController");
var FilterController = /** @class */ (function (_super) {
    __extends(FilterController, _super);
    function FilterController() {
        return _super.call(this, true) || this;
    }
    FilterController.prototype.ResetData = function () {
        this.DATA = {
            dict: {},
            listKeys: []
        };
    };
    FilterController.prototype.doRegisterFilterEmpty = function (key) {
        if (!this.DATA.dict[key]) {
            this.DATA.dict[key] = {
                isFilterActive: false,
                dataAvail: [],
                selectedKeys: [],
                filterPlaceHolder: "",
                filterTitle: "",
                filterValue: ""
            };
        }
        if (this.DATA.listKeys.indexOf(key) == -1) {
            this.DATA.listKeys.push(key);
        }
    };
    FilterController.prototype.doRegisterFilterData = function (key, data) {
        if (!this.DATA.dict[key]) {
            this.DATA.dict[key] = data;
        }
        if (this.DATA.listKeys.indexOf(key) == -1) {
            this.DATA.listKeys.push(key);
        }
    };
    FilterController.prototype.doDeleteFilter = function (key) {
        delete this.DATA.dict[key];
        var new_list = this.DATA.listKeys.slice();
        var index = new_list.indexOf(key);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.listKeys = new_list;
    };
    FilterController.prototype.doSetFilterDataAvail = function (key, data, triggerEvent) {
        this.DATA.dict[key].dataAvail = data;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    FilterController.prototype.doSetFilterActive = function (key, isActive, triggerEvent) {
        this.DATA.dict[key].isFilterActive = isActive;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    FilterController.prototype.doSetFilterTitle = function (key, title, triggerEvent) {
        this.DATA.dict[key].filterTitle = title;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    FilterController.prototype.doSetFilterValue = function (key, value, triggerEvent) {
        this.DATA.dict[key].filterValue = value;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    FilterController.prototype.doSetFilterPlaceHolder = function (key, placeholder, triggerEvent) {
        this.DATA.dict[key].filterPlaceHolder = placeholder;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    FilterController.prototype.doSetFilterDataSelected = function (key, data, triggerEvent) {
        this.DATA.dict[key].selectedKeys = data;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    FilterController.prototype.getFilterItemByKey = function (key) {
        return this.DATA.dict[key];
    };
    FilterController.prototype.isFilterItemExists = function (key) {
        if (this.DATA.listKeys.indexOf(key) < 0) {
            return false;
        }
        else {
            return true;
        }
    };
    FilterController.prototype.onFilterChanged = function (key, isFiltered, filteredKey, Action, needUpdate) {
        if (Action == "add") {
            this.DATA.dict[key].selectedKeys.push(filteredKey);
        }
        if (Action == "remove") {
            var new_list = this.DATA.dict[key].selectedKeys.slice();
            var index = new_list.indexOf(filteredKey);
            if (index !== -1) {
                new_list.splice(index, 1);
            }
            this.DATA.dict[key].selectedKeys = new_list;
        }
        if (Action == "checkbox") {
            this.DATA.dict[key].isFilterActive = isFiltered;
        }
        if (needUpdate) {
            this.Update(key);
        }
    };
    FilterController.prototype.getAllFilterItems = function () {
        var _ret = [];
        for (var i = 0; i < this.DATA.listKeys.length; i++) {
            _ret.push(this.DATA.dict[this.DATA.listKeys[i]]);
        }
        return _ret;
    };
    return FilterController;
}(BaseController_1.BaseController));
exports.FilterController = FilterController;



//////////////////
// WEBPACK FOOTER
// ./src/shared/controllers/FilterController.ts
// module id = 859
// module chunks = 0